import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
// import { Link } from "react-router-dom";    ← commented out – not used in this component

export default function About() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      easing: "ease-out",
      offset: 40,
    });
  }, []);

  const iconStyle = {
    fontSize: "40px",
    color: "#684df4",
  };

  return (
    <section id="about" className="about aboutSection">
      <div className="container-fluid px-0">
        <div className="row g-0 justify-content-center">
          <div className="col-12">
            <div className="text-center px-3 px-md-5">
              <div className="section-title" data-aos="fade-down" data-aos-delay="100">
                <h2 data-aos="zoom-in" data-aos-delay="150">About Us</h2>
                <h3 data-aos="zoom-in" data-aos-delay="200">
                  Innovative <span data-aos="fade-up" data-aos-delay="250">IT Solutions</span> For Modern Businesses
                </h3>
              </div>

              <p
                className="fst-italic"
                style={{ textAlign: "center", maxWidth: "900px", margin: "0 auto 20px" }}
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <span data-aos="fade-right" data-aos-delay="320">Technic Mentors is your trusted IT services partner with over</span>{" "}
                <strong data-aos="zoom-in" data-aos-delay="350">20+ years of experience</strong>{" "}
                <span data-aos="fade-left" data-aos-delay="380">in delivering extraordinary software and technology solutions. We specialize in custom software development, cloud solutions, cybersecurity, and IT consulting. Our team of certified professionals is dedicated to transforming your business challenges into innovative digital solutions that drive growth and efficiency.</span>
              </p>

              <p
                style={{ textAlign: "center", maxWidth: "900px", margin: "0 auto", fontSize: "15px" }}
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <span data-aos="fade-right" data-aos-delay="420">From startups to enterprises, we provide value-added, quality products and services tailored to your unique needs.</span>{" "}
                <span data-aos="fade-left" data-aos-delay="450">Our commitment to excellence has made us the preferred choice for businesses seeking cutting-edge technology solutions.</span>
              </p>

              <div className="row justify-content-center mt-4" data-aos="fade-up" data-aos-delay="500">
                {/* Certified Company */}
                <div className="col-lg-3 col-md-6 col-sm-6 mt-3">
                  <div
                    data-aos="flip-left"
                    data-aos-delay="550"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <i className="fas fa-award" style={iconStyle}></i>
                  </div>
                  <div className="mt-2">
                    <p
                      className="pFont mb-1"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                      data-aos="fade-up"
                      data-aos-delay="570"
                    >
                      Certified Company
                    </p>
                    <p style={{ fontSize: "14px", margin: 0 }} data-aos="fade-up" data-aos-delay="590">
                      ISO Certified & Registered
                    </p>
                  </div>
                </div>

                {/* Expert Team */}
                <div className="col-lg-3 col-md-6 col-sm-6 mt-3">
                  <div
                    data-aos="flip-left"
                    data-aos-delay="600"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <i className="fas fa-users" style={iconStyle}></i>
                  </div>
                  <div className="mt-2">
                    <p
                      className="pFont mb-1"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                      data-aos="fade-up"
                      data-aos-delay="620"
                    >
                      Expert Team
                    </p>
                    <p style={{ fontSize: "14px", margin: 0 }} data-aos="fade-up" data-aos-delay="640">
                      30+ Skilled Professionals
                    </p>
                  </div>
                </div>

                {/* 20+ Years */}
                <div className="col-lg-3 col-md-6 col-sm-6 mt-3">
                  <div
                    data-aos="flip-left"
                    data-aos-delay="650"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <i className="fas fa-clock" style={iconStyle}></i>
                  </div>
                  <div className="mt-2">
                    <p
                      className="pFont mb-1"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                      data-aos="fade-up"
                      data-aos-delay="670"
                    >
                      20+ Years
                    </p>
                    <p style={{ fontSize: "14px", margin: 0 }} data-aos="fade-up" data-aos-delay="690">
                      Industry Experience
                    </p>
                  </div>
                </div>

                {/* 500+ Projects */}
                <div className="col-lg-3 col-md-6 col-sm-6 mt-3">
                  <div
                    data-aos="flip-left"
                    data-aos-delay="700"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <i className="fas fa-thumbs-up" style={iconStyle}></i>
                  </div>
                  <div className="mt-2">
                    <p
                      className="pFont mb-1"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                      data-aos="fade-up"
                      data-aos-delay="720"
                    >
                      500+ Projects
                    </p>
                    <p style={{ fontSize: "14px", margin: 0 }} data-aos="fade-up" data-aos-delay="740">
                      Successfully Delivered
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}